import { selectError, selectLastUpdate, selectLoadingOrInitial, selectPayload, } from "@single-js/common/util/loading-state-machine";
import { selectRoute } from "data/selectors/routes";
import { selectNodes } from "data/selectors/topology";
import _ from "lodash";
import { createSelector } from "reselect";
import { ALL_HOSTS_COLUMNS } from "view/hosts/columns-info";
import { ALL_HOST_PAGE_COLUMNS } from "view/topology/columns-info";
export const selectHostsLoading = (s) => selectLoadingOrInitial(s.hosts.hosts) ||
    selectLoadingOrInitial(s.topology.topology);
export const selectHostsLastUpdate = (s) => _.max([
    selectLastUpdate(s.hosts.hosts),
    selectLastUpdate(s.topology.topology),
]);
export const selectHostsError = (s) => selectError(s.hosts.hosts) ||
    selectError(s.topology.topology);
export const selectHosts = (s) => {
    const hostsPayload = selectPayload(s.hosts.hosts);
    if (hostsPayload) {
        return hostsPayload.hosts;
    }
};
export const selectHostsSort = (s) => s.hosts.hostsSort;
export const selectHostNodesSort = (s) => s.hosts.hostNodesSort;
export const deriveHosts = createSelector(selectHosts, selectNodes, (hosts, allNodes) => {
    if (hosts) {
        return _.map(hosts, (host) => {
            let nodes = [];
            if (allNodes) {
                nodes = _.filter(allNodes, (node) => node.host === host.address);
            }
            return { ...host, nodes };
        });
    }
});
export const selectSortedHosts = createSelector(deriveHosts, selectHostsSort, (hosts, sort) => {
    if (sort && hosts) {
        const { direction, columnId } = sort;
        const columnInfo = _.find(ALL_HOSTS_COLUMNS, (col) => col.id === columnId);
        if (!columnInfo) {
            throw new Error(`Expected column ${columnId} to be defined while sorting hosts`);
        }
        return _.orderBy(hosts, [columnInfo.getValue], direction);
    }
    else if (hosts) {
        return hosts;
    }
});
export const selectCurrentHostAddress = (s) => selectRoute(s).params.hostId;
export const selectCurrentHost = createSelector(deriveHosts, selectCurrentHostAddress, (hosts, hostAddress) => {
    if (hosts && hostAddress) {
        return _.find(hosts, (host) => host.address === hostAddress);
    }
});
export const selectSortedHostNodes = createSelector(selectCurrentHost, selectHostNodesSort, (host, sort) => {
    if (host) {
        if (sort) {
            const { direction, columnId } = sort;
            const columnInfo = _.find(ALL_HOST_PAGE_COLUMNS, (col) => col.id === columnId);
            if (!columnInfo) {
                throw new Error(`Expected column ${columnId} to be defined while sorting hosts' nodes`);
            }
            return _.orderBy(host.nodes, [columnInfo.getValue], direction);
        }
        else {
            return host.nodes;
        }
    }
});
export function selectIsPhysicalMonitoringEnabled(s) {
    return s.hosts.physicalMonitoringEnabled;
}
